import { I18nShape } from '@tribeplatform/react-components/i18n'

import { BlockType, RegisteredBlock } from '../../types/index.js'
import { CardFooterBlock as Component } from './Block.js'
import { CardFooterProps } from './types.js'

export const RegisteredCardFooterBlock = (
  _intl: I18nShape,
): RegisteredBlock<CardFooterProps> => ({
  recommendedName: 'Card.Footer',
  Component,
  config: {
    type: BlockType.BuildingBlock,
    defaultProps: {
      withBorder: true,
    },
  },
})
